import { UserRole, UserT } from 'business/definitions';

export const CreateMultipleUserActionType = {
    addUser: 'ADD_USER',
    replaceUsers: 'REPLACE_USERS',
    updateUser: 'UPDATE_USER',
    removeUser: 'REMOVE_USER',
    addRole: 'ADD_ROLE',
    removeRole: 'REMOVE_ROLE',
    setSendEmail: 'SET_SEND_EMAIL',
    changeAuthMethod: 'CHANGE_AUTH_METHOD',
} as const;

export type UserCreationType = Pick<
    UserT,
    | 'email'
    | 'firstname'
    | 'lastname'
    | 'gender'
    | 'job'
    | 'roles'
    | 'authMethods'
>;

export type CreateMultipleUserState = {
    users: UserCreationType[];
    shouldSendEmail: boolean;
    isDirty: boolean;
};

export type CreateMultipleUserAction =
    | {
          type: 'ADD_USER';
          user: Partial<UserCreationType>;
      }
    | {
          type: 'REPLACE_USERS';
          users: Partial<UserCreationType>[];
      }
    | {
          type: 'UPDATE_USER';
          index: number;
          user: Partial<UserCreationType>;
      }
    | {
          type: 'REMOVE_USER';
          index: number;
      }
    | {
          type: 'ADD_ROLE';
          role: UserRole;
      }
    | { type: 'REMOVE_ROLE'; role: UserRole }
    | {
          type: 'SET_SEND_EMAIL';
          shouldSendEmail: boolean;
      }
    | {
          type: 'CHANGE_AUTH_METHOD';
          authMethod: string;
      };
